import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wip36tktt20p">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-green/85 md:text-3xl" data-id="element-1" data-mp="28te198rqp1kz">
      🌸 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Botiquín Bach Completo',
      content_type: 'product',
      value: 19,
      currency: 'USD'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-sageMist selection:text-brand-green" data-id="element-2" data-mp="3rd1all5o5hp3">
      <UrgencyBanner data-id="element-3" data-mp="2zld0l5ad579f" />
      <main data-id="element-4" data-mp="2zlv8x0aavbxp">
        <Hero data-id="element-5" data-mp="2zmepackaxs9m" />
        <PackContents data-id="element-6" data-mp="2zmo7vf30ox5a" />
        <InitialTestimonials data-id="element-7" data-mp="2zng0ch1bierc" />
        <PainPoints data-id="element-8" data-mp="33m5ck6amdq9e" />
        <LaunchOffer data-id="element-9" data-mp="33nq9g2keplaf" />
        <MoreTestimonials data-id="element-10" data-mp="33mymth8sexwa" />
        <FAQ data-id="element-11" data-mp="38lrp0dimj2h5" />
        <CostComparison data-id="element-12" data-mp="38m1f013o59mu" />
        <TransitionPhrase data-id="element-13" data-mp="38kqb81a841vq" />
        <EmotionalClose data-id="element-14" data-mp="38kgk2adfzoog" />
      </main>
      <Footer data-id="element-15" data-mp="3dkl4gbhh13jy" />
      <FloatingNotification data-id="element-16" data-mp="3dle4ktlxcut4" />
    </div>;
}